// Copyright (c) 2017 VMware, Inc. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import {Component, Input, OnInit, OnChanges} from '@angular/core';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import {Label} from "../service/interface";
import {LabelColor} from "../shared/shared.const";


@Component({
    selector: 'hbr-label-piece',
    template: `<label class="label" [ngStyle]="{'background-color': labelColor?.color, 'color': labelColor?.textColor, 'border': labelColor?.color == '#FFFFFF'? '1px solid #A1A1A1': 'none'}" [style.max-width.px]="labelWidth">
    <clr-icon *ngIf="label.scope=='p'" shape="organization"></clr-icon>
    <clr-icon *ngIf="label.scope=='g'" shape="administrator"></clr-icon>
     {{label.name}}
</label>
`,
    styles: [`.label{border:none;color:#222;display:inline-block;justify-content:flex-start;margin:0;overflow:hidden;text-overflow:ellipsis;line-height:.875rem}.label clr-icon{margin-right:3px}.btn-group .dropdown-menu clr-icon{display:block}`]
})

export class LabelPieceComponent implements OnInit, OnChanges {
    @Input() label: Label;
    @Input() labelWidth: number;
    labelColor: {[key: string]: string};

    ngOnChanges(): void {
        if (this.label) {
            let color = this.label.color;
            if (color === '') {color = '#FFFFFF'; }
            this.labelColor = LabelColor.find(data => data.color === color);
        }
    }

    ngOnInit(): void { }
}
